import { render, staticRenderFns } from "./ModeloVehiculo.vue?vue&type=template&id=57767e54&scoped=true&"
import script from "./ModeloVehiculo.vue?vue&type=script&lang=js&"
export * from "./ModeloVehiculo.vue?vue&type=script&lang=js&"
import style0 from "./ModeloVehiculo.vue?vue&type=style&index=0&id=57767e54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57767e54",
  null
  
)

export default component.exports